import SC from 'styled-components'

export const Column = SC.div`
  flex: 1;
  margin-right: 30px;
`
